import React from "react";
import { useNavigate } from "react-router";
import { PageNotFound } from "../../assets";

const Page404 = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-light error-boundary">
      <div className="d-flex justify-content-center align-items-center flex-column px-3">
        <img height={75} width={75} src={PageNotFound} alt="BVS" />
        <h4>404 - Page Not Found</h4>
        <p className="not-found__info w-100 text-center mt-4 m-0">
          Oops! The page you’re looking for doesn’t exist or has been moved
        </p>
        <div className="d-flex justify-content-center align-items-between flex-row flex-wrap mt-4">
          <button
            className="contact-us-hero-button"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default Page404;
